import moment from 'moment';
import React, { useState } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import notification from '../../helpers/notification';
import fileDownload from 'js-file-download';
import ApiService from '../../api/ApiService';

function EventCard({ event }) {
  const navigate = useNavigate();
  const [downloading, setDownloading] = useState(false);

  const handleCalenderDownload = async (file) => {
    setDownloading(true);
    try {
      const res = await ApiService.downloadCalendar(file);
      fileDownload(res, 'calendar-file.ics');
    } catch (error) {
      console.error(error);
      notification('error', 'Unable to download calendar file!');
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="content-card">
      <div className="card-img-top bg-light d-flex justify-content-center align-items-center" style={{ height: '400px', overflow: 'hidden' }}>
        <img
          loading="lazy"
          src={`${process.env.REACT_APP_S3_URL}/uploads/event/${event?.image}`}
          alt={event?.title}
          style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
        />
      </div>

      <div className="content-info">
        <NavLink to={`/Event-Details/${event?.slug}`}>
          <h2>{event?.title}</h2>
        </NavLink>

        <h5>{moment(event.startDate).format('dddd, D MMMM YYYY')}</h5>

        <p>{event?.description.substring(0, 200) + '...'}</p>

        <button
          onClick={() => navigate(`/Event-Details/${event?.slug}`)}
          className="custom-btn-cls box-hover my-4"
        >
          Read more
        </button>
      </div>
    </div>
  );
}

export default EventCard;
